import React from 'react'
import { Switch,Route,  withRouter} from 'react-router-dom'
import LogIn from './Components/Login'
import AuthAppInstructions from './Components/AuthAppInstructions'
import ClientError from './Components/ClientError'

const Navigation = () => {  
    return (
        <div>
        <Switch>  
            <Route key = "Cognito SSO" exact path="/" component={LogIn}></Route>    
            <Route key = "LogIn"  path="/login" component={LogIn}></Route>  
            <Route key = "NewUser"  path="/newuser" component={LogIn}></Route> 
            <Route key = "AuthAppInstructions" path="/AuthAppInstructions" component={AuthAppInstructions}></Route>
            <Route key = "ClientError" path="/clienterror" component={ClientError}></Route>
        </Switch>
      

        </div>
    )
}
export default  withRouter(Navigation);